import { NotificationConditionTypeEnum } from '@/entities/notifications'
import { type CreateOrUpdateNotificationModel } from '@/shared/api'
import { formatDayjsToDateTimeString } from '@/shared/lib/form-utils'

import { type NotificationFormModel } from '..'

export function getNotificationSubmitRequestByFormValues(
  values: NotificationFormModel,
  isEdit: boolean,
): CreateOrUpdateNotificationModel {
  return {
    name: values.name,
    description: values.description,
    conditionType: values.conditionType,
    pictureFileId: values.pictureFile?.id ?? null,
    ...(values.conditionType === NotificationConditionTypeEnum.AtTime
      ? isEdit
        ? {
            // редактирование → только sendOnDate
            sendOnDate:
              values.dates &&
              values.dates.length === 1 &&
              values.dates[0].date &&
              values.dates[0].time
                ? formatDayjsToDateTimeString(
                    values.dates[0].date,
                    values.dates[0].time,
                  )
                : null,
          }
        : {
            // создание → массив dates
            dates:
              values.dates &&
              (values.dates
                .map((d) =>
                  d.date && d.time
                    ? {
                        sendOnDate: formatDayjsToDateTimeString(d.date, d.time),
                      }
                    : null,
                )
                .filter(Boolean) as { sendOnDate: string }[]),
          }
      : {}),
  }
}
